import { Injectable } from '@angular/core';
import { IrisStorage } from './storage';

@Injectable({
  providedIn: 'root',
})
export class IrisInMemoryStorage implements IrisStorage {
  private readonly values: Record<string, unknown> = {};

  getItem<T>(key: string): T | undefined {
    return this.values[key] as T;
  }

  setItem<T>(key: string, value: T): T {
    this.values[key] = value;
    return value;
  }

  removeItem(key: string): void {
    delete this.values[key];
  }
}
